<template>
<div
  class="experiencia-invitaciones"
  id="precios-section"
>    
    <!-- PANTALLA DE SELECCIÓN DE PAQUETES -->
    <section ref="paquetesSection" class="seccion-paquetes">
      <div class="paquetes-bg"></div>
      <div class="paquetes-overlay"></div>
      
      <div class="paquetes-content">

        <span class="paquetes-tag">
          Planes y Herramientas
        </span>

        <h1 class="paquetes-title">
          Selecciona tu <br />
          <span>Experiencia Digital</span>
        </h1>

        <p class="paquetes-subtitle">
          Ofrecemos dos paquetes:
          Básico y Premium,
          ambos con diseño visual moderno
          y herramientas que facilitan tu evento.
        </p>

        <!-- CONTADOR DE OFERTA -->
<div class="oferta-contador-box">
  <p class="oferta-txt-alerta">
    ⚠️ ¡PROMO DE ESTA SEMANA! La oferta termina en:
  </p>

  <div class="contador-timer">

    <div class="timer-item">
      <span>{{ tiempoRestante.dias }}</span>d
    </div>

    <div class="timer-item">
      <span>{{ tiempoRestante.horas }}</span>h
    </div>

    <div class="timer-item">
      <span>{{ tiempoRestante.minutos }}</span>m
    </div>

    <div class="timer-item">
      <span>{{ tiempoRestante.segundos }}</span>s
    </div>

  </div>
</div>
        <!-- GRID DE PAQUETES -->
        <div class="paquetes-grid">
          
          <!-- PAQUETE BÁSICO -->
          <div class="paquete-card">

            <!-- SELLO -->
            <img
              src="@/assets/llacre.png"
              class="sello-lacre"
              alt="Sello de calidad"
            />

            <div class="paquete-header">

              <span class="badge-paquete">
                Funcional y Hermosa
              </span>

              <h3>Basico</h3>

              <!-- PRECIOS CON DESCUENTO -->
              <div class="paquete-precio">
                <span class="precio-antes">$190 USD</span>
                $150 <span>USD</span>
              </div>

              <p class="paquete-desc-corta">
                Ideal si quieres una invitación funcional y hermosa,
                con control general de tus asistentes.
              </p>
              
              <div class="separador-modulos">
                ✦ Modulos incluidos:
              </div>
            </div>
            
            <!-- LISTA -->
            <ul class="paquete-caracteristicas visible">

              <li>
                <span>✔</span>
                Confirmación de asistencia (RSVP)
              </li>

              <li>
                <span>✔</span>
                Galería para mostrar hasta 10 fotos
              </li>

              <li>
                <span>✔</span>
                Música de fondo
              </li>

              <li>
                <span>✔</span>
                Mesa de regalos
              </li>

              <li>
                <span>✔</span>
                Cuenta regresiva
              </li>

              <li>
                <span>✔</span>
                Ubicaciones con mapa
              </li>

             
              <li>
                <span>✔</span>
                Enlace personalizado
                (Subdominio con tu nombre)
              </li>

              <li>
                <span>✔</span>
                Envíos ilimitados
              </li>

              <li>
                <span>✔</span>
                Acceso al sistema con usuario y contraseña
                para monitorear en tiempo real qué invitados
                han confirmado su asistencia
              </li>

            </ul>
            
            <!-- EXTRAS -->
            <div class="tarjeta-extras-desplegable">

              <button
                class="btn-detalles-link-tarjeta"
                @click="toggleExtras('basico')"
              >
                {{
                  abiertoExtrasBasico
                    ? '✦ Ocultar Extras y Costos'
                    : '✦ Ver Extras y Costos Opcionales'
                }}
              </button>
              
              <div
                ref="desplegableExtrasBasico"
                class="extras-contenido-interno"
              >

                <ul class="lista-extras-interna">

                  <li>
                    <strong>Agrega Segundo Idioma:</strong>
                    <span>+$45 USD</span>
                  </li>

                  <li>
                    <strong>Módulos Extra (Corte de honor, agregar video a invitación, etc):</strong>
                    <span>+$30 USD c/u</span>
                  </li>

                </ul>
              </div>
            </div>

            <!-- BOTON -->
            <button
              class="btn-seleccionar"
              @click="contactarPaqueteDirecto('Básico')"
            >

              <span class="btn-text">
                Contactar
              </span>

              <div class="btn-glow"></div>
            </button>
          </div>

          <!-- PREMIUM -->
          <div class="paquete-card premium-destacado">

            <img
              src="@/assets/llacre2.png"
              class="sello-lacre"
              alt="Sello de calidad"
            />

            <div class="paquete-header">

              <span class="badge-paquete destacado">
                Completa y Personalizada
              </span>

              <h3>Premium</h3>

              <!-- PRECIOS CON DESCUENTO -->
              <div class="paquete-precio">
                <span class="precio-antes">$249 USD</span>
                $199 <span>USD</span>
              </div>

              <p class="paquete-desc-corta">
                Perfecto si deseas una experiencia totalmente personalizada,
                nominal y completa.
              </p>
              
              <div class="separador-modulos">
                ✦ Módulos incluidos:
              </div>
            </div>
            
            <!-- LISTA -->
            <ul class="paquete-caracteristicas visible">

              <li class="incluye-todo">
                ✦ INCLUJE TODO LO DEL BÁSICO, MÁS:
              </li>

              <li>
                <span>✔</span>
                Invitaciones personalizadas con nombre del invitado
              </li>

              <li>
                <span>✔</span>
                Número de pases asignados y asignación de mesa
                <strong class="alerta-platillos">
                  (Crucial si tienes un número de platillos ya definidos)
                </strong>
              </li>

              <li>
                <span>✔</span>
                Tus invitados pueden subir las fotos que tomen
                el día del evento al álbum de fotos
              </li>

              <li>
                <span>✔</span>
                Sistema avanzado de gestión:
                sube tu lista de invitados,
                asigna pases y mesas,
                y el sistema adapta automáticamente
                cada invitación
              </li>

              <li>
                <span>✔</span>
                Lector de código QR
                para controlar el acceso en el evento
              </li>

              <li>
                <span>✔</span>
                Usuario y contraseña
                con acceso completo a todas las funciones
              </li>

              <li>
                <span>✔</span>
                Sección adicional con información de hospedaje
                (opcional)
              </li>

            </ul>
            
            <!-- EXTRAS -->
            <div class="tarjeta-extras-desplegable">

              <button
                class="btn-detalles-link-tarjeta"
                @click="toggleExtras('premium')"
              >
                {{
                  abiertoExtrasPremium
                    ? '✦ Ocultar Extras y Costos'
                    : '✦ Ver Extras y Costos Opcionales'
                }}
              </button>
              
              <div
                ref="desplegableExtrasPremium"
                class="extras-contenido-interno"
              >

                <ul class="lista-extras-interna">

                  <li>
                    <strong>Contraseña:</strong>
                    Ingreso a invitacion con contraseña (Opcional).
                  </li>

                  <li>
                    <strong>Segundo Idioma:</strong>
                    <span>+$45 USD</span>
                  </li>

                  <li>
                    <strong>Módulos Extra (Corte de honor, agregar video a invitación, etc):</strong>
                    <span>+$30 USD c/u</span>
                  </li>

                </ul>
              </div>
            </div>

            <!-- BOTON -->
            <button
              class="btn-seleccionar btn-premium-action"
              @click="contactarPaqueteDirecto('Premium')"
            >

              <span class="btn-text">
                Contactar
              </span>

              <div class="btn-glow"></div>
            </button>
          </div>
        </div>

        <!-- EXTRAS ABAJO -->
        <div class="extras-visibles">

          <h4 class="extras-title">
            ✦ Opcionales y Módulos Extras ✦
          </h4>

          <ul class="lista-extras">

            <li>
              <strong>Opcional:</strong>
              Acceso seguro a la invitación mediante contraseña.
            </li>

            <li>
              <strong>Segundo Idioma:</strong>
              Agrega opción de un segundo idioma
              por <span>$45 USD</span>
              (especificar al contratar).
            </li>

            <li>
              <strong>Módulos Adicionales:</strong>
              Corte de honor,
              agregar video, etc.
              por <span>$30 USD c/u</span>.
            </li>

          </ul>

          <p class="nota-subdominio">
            Las dos opciones tienen subdominio con el nombre
            de la festejada es decir el link es personalizado
            a su nombre.
          </p>
        </div>

        <!-- FOOTER -->
        <div class="beneficio-footer">

          <h3>
            ¿Por que elegirnos?
          </h3>

          <p>
            Porque no solo entregamos una invitación bonita,
            hino una herramienta organizada y personalizada,
            pensada para hacer tu evento más fácil y especial.

            Nos adaptamos a tus ideas,
            colores y estilo para crear una experiencia única
            desde el primer momento.
          </p>

        </div>

      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'

export default {

  name: 'ExperienciaInvitacionesPlanes',

  setup() {

    const esMexico = ref(false)

    const abiertoExtrasBasico = ref(false)

    const abiertoExtrasPremium = ref(false)

    const paquetesSection = ref(null)

    const desplegableExtrasBasico = ref(null)

    const desplegableExtrasPremium = ref(null)

  // LÓGICA DE LA CUENTA REGRESIVA A 2 SEMANAS
// CONTADOR
const tiempoRestante = ref({
  dias: '00',
  horas: '00',
  minutos: '00',
  segundos: '00'
})

let timerInterval = null

const iniciarContadorLoop = () => {

  // 🔥 FECHA OBJETIVO = HOY + 14 DÍAS
  const fechaObjetivo = new Date()

  fechaObjetivo.setDate(
    fechaObjetivo.getDate() + 14
  )

  const actualizarContador = () => {

    const ahora = new Date()

    const diferencia = fechaObjetivo - ahora

    // SI TERMINA
    if (diferencia <= 0) {

      tiempoRestante.value = {
        dias: '00',
        horas: '00',
        minutos: '00',
        segundos: '00'
      }

      clearInterval(timerInterval)

      return
    }

    // 🔥 CÁLCULOS
    const dias = Math.floor(
      diferencia / (1000 * 60 * 60 * 24)
    )

    const hrs = Math.floor(
      (diferencia / (1000 * 60 * 60)) % 24
    )

    const mins = Math.floor(
      (diferencia / (1000 * 60)) % 60
    )

    const segs = Math.floor(
      (diferencia / 1000) % 60
    )

    // 🔥 FORMATO
    tiempoRestante.value = {

      dias:
        dias < 10
          ? '0' + dias
          : dias.toString(),

      horas:
        hrs < 10
          ? '0' + hrs
          : hrs.toString(),

      minutos:
        mins < 10
          ? '0' + mins
          : mins.toString(),

      segundos:
        segs < 10
          ? '0' + segs
          : segs.toString()
    }
  }

  // INICIAR INMEDIATAMENTE
  actualizarContador()

  // ACTUALIZAR CADA SEGUNDO
  timerInterval = setInterval(
    actualizarContador,
    1000
  )
}

onMounted(() => {

  // INICIAR CONTADOR
  iniciarContadorLoop()

  // SOLO PARA DEFINIR EL TELÉFONO
  const language =
    navigator.language ||
    navigator.userLanguage

  if (
    language.includes('es-MX') ||
    language.toLowerCase().includes('mx')
  ) {

    esMexico.value = true

  } else {

    esMexico.value = false
  }
})

    onUnmounted(() => {
      if (timerInterval) clearInterval(timerInterval)
    })

    // CONTACTO
    const contactarPaqueteDirecto = (paquete) => {

      // MÉXICO
      let numero = '528341441992'

      // USA
      if (!esMexico.value) {
        numero = '16128072269'
      }

      const mensaje = encodeURIComponent(
        `Hola, estoy interesada en el paquete ${paquete} con el precio de promoción.`
      )

      window.open(
        `https://wa.me/${numero}?text=${mensaje}`,
        '_blank'
      )
    }

    // TOGGLE EXTRAS
    const toggleExtras = (tipo) => {

      if (tipo === 'basico') {

        abiertoExtrasBasico.value =
          !abiertoExtrasBasico.value

        gsap.to(
          desplegableExtrasBasico.value,
          {

            height:
              abiertoExtrasBasico.value
                ? 'auto'
                : 0,

            opacity:
              abiertoExtrasBasico.value
                ? 1
                : 0,

            duration: 0.35,

            ease: 'power2.out'
          }
        )

      } else {

        abiertoExtrasPremium.value =
          !abiertoExtrasPremium.value

        gsap.to(
          desplegableExtrasPremium.value,
          {

            height:
              abiertoExtrasPremium.value
                ? 'auto'
                : 0,

            opacity:
              abiertoExtrasPremium.value
                ? 1
                : 0,

            duration: 0.35,

            ease: 'power2.out'
          }
        )
      }
    }

    return {

      esMexico,

      abiertoExtrasBasico,

      abiertoExtrasPremium,

      paquetesSection,

      desplegableExtrasBasico,

      desplegableExtrasPremium,

      tiempoRestante,

      toggleExtras,

      contactarPaqueteDirecto
    }
  }
}
</script>

<style scoped>
.experiencia-invitaciones {
  width: 100%;
  min-height: 100vh;
  background: #0d0b0c;
}

/* ==========================================================================
   PANTALLA DE SELECCIÓN DE PAQUETES
   ========================================================================== */
.seccion-paquetes {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 4%;
  overflow: hidden;
}

.paquetes-bg {
  position: absolute;
  inset: 0;
  background-image: url('@/assets/principal.jpg');
  background-size: cover;
  background-position: center;
  transform: scale(1.05);
}

.paquetes-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(13,11,12,0.94), rgba(13,11,12,0.98));
}

.paquetes-content {
  position: relative;
  z-index: 5;
  width: 100%;
  max-width: 1050px;
  text-align: center;
}

.paquetes-tag {
  display: inline-block;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: 5px;
  text-transform: uppercase;
  color: #f0b2bc;
  font-size: 0.85rem;
  margin-bottom: 15px;
}

.paquetes-title {
  font-size: 3.8rem;
  color: white;
  line-height: 1.15;
 
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
}

.paquetes-title span {
  font-family: 'ludovica', serif;
  font-style: italic;
   padding-right: 16px;
    padding-left: 16px;

  font-weight: 400;
  background: linear-gradient(45deg, #f0b2bc, #fff3f5, #e293a0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.paquetes-subtitle {
  color: #b5b5b5;
  font-family: 'Montserrat', sans-serif;
  margin: 20px auto 30px;
  font-size: 1.05rem;
  line-height: 1.6;
  max-width: 700px;
}

/* ESTILOS DEL CONTADOR DE OFERTA */
.oferta-contador-box {
  background: rgba(240, 178, 188, 0.07);
  border: 1px solid rgba(240, 178, 188, 0.2);
  border-radius: 16px;
  padding: 15px 25px;
  max-width: 450px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.oferta-txt-alerta {
  font-family: 'Montserrat', sans-serif;
  color: #fff3f5;
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.5px;
}

.contador-timer {
  display: flex;
  gap: 15px;
}

.timer-item {
  font-family: 'Montserrat', sans-serif;
  color: #b5b5b5;
  font-size: 0.85rem;
}

.timer-item span {
  font-family: 'Montserrat', sans-serif;
  color: #f0b2bc;
  font-size: 1.4rem;
  font-weight: 700;
  margin-right: 2px;
}

.paquetes-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 35px;
  width: 100%;
  margin: 0 auto;
}

.paquete-card {
  position: relative;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 28px;
  padding: 50px 35px 40px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  transition: transform 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease;
}

.premium-destacado {
  background: linear-gradient(145deg, rgba(255,255,255,0.04) 0%, rgba(240,178,188,0.02) 100%);
  border: 1px solid rgba(240, 178, 188, 0.25);
}

.paquete-card:hover {
  transform: translateY(-6px);
  border-color: rgba(240, 178, 188, 0.35);
  box-shadow: 0 20px 40px rgba(0,0,0,0.35);
}

.premium-destacado:hover {
  border-color: rgba(240, 178, 188, 0.6);
  box-shadow: 0 20px 40px rgba(0,0,0,0.4), 0 0 25px rgba(240, 178, 188, 0.12);
}

.sello-lacre {
  position: absolute;
  top: -15px;
  right: 25px;
  width: 65px;
  height: auto;
  z-index: 10;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.5));
  pointer-events: none;
  transition: transform 0.4s ease;
}

.paquete-card:hover .sello-lacre {
  transform: scale(1.08) rotate(5deg);
}

.badge-paquete {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #a5a5a5;
  display: block;
  margin-bottom: 8px;
}

.badge-paquete.destacado {
  color: #f0b2bc;
  font-weight: 600;
}

.paquete-header h3 {
  font-family: 'ludovica', serif;
  color: white;
  font-size: 2.4rem;
  margin: 0 0 5px;
  font-weight: 400;
}

.paquete-precio {
  font-family: 'Montserrat', sans-serif;
  color: white;
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 12px;
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.precio-antes {
  font-size: 1.2rem;
  color: #777777;
  text-decoration: line-through;
  font-weight: 400;
}

.paquete-precio span {
  font-size: 1.2rem;
  color: #f0b2bc;
  font-weight: 500;
  margin-left: -5px;
}

.paquete-desc-corta {
  color: #b0b0b0;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  line-height: 1.4;
  margin: 0 0 10px;
  min-height: 42px;
}

.separador-modulos {
  color: #f0b2bc;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 1px;
  padding-bottom: 12px;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
  margin-bottom: 20px;
}

.paquete-caracteristicas.visible {
  list-style: none;
  padding: 0;
  margin: 0 0 25px 0;
  height: auto !important;
  opacity: 1 !important;
  overflow: visible;
  flex-grow: 1;
}

.paquete-caracteristicas li {
  color: #cccccc;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  margin-bottom: 14px;
  line-height: 1.45;
  display: flex;
  align-items: flex-start;
}

.paquete-caracteristicas li span {
  color: #f0b2bc;
  margin-right: 10px;
  font-size: 0.85rem;
}

.paquete-caracteristicas li.incluye-todo {
  color: #f0b2bc;
  font-weight: 700;
  font-size: 0.8rem;
  letter-spacing: 1px;
  margin-bottom: 18px;
}

.alerta-platillos {
  color: #fff3f5;
  background: rgba(240, 178, 188, 0.15);
  padding: 2px 6px;
  border-radius: 6px;
  font-weight: 600;
  display: inline-block;
  margin-top: 4px;
}

.tarjeta-extras-desplegable {
  width: 100%;
  margin-bottom: 20px;
  border-top: 1px dashed rgba(255, 255, 255, 0.06);
  padding-top: 15px;
}

.btn-detalles-link-tarjeta {
  background: transparent;
  border: none;
  color: #f0b2bc;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  padding: 5px 0;
  text-align: left;
  display: block;
  width: 100%;
  transition: color 0.3s ease;
}

.btn-detalles-link-tarjeta:hover {
  text-decoration: underline;
  color: #fff3f5;
}

.extras-contenido-interno {
  height: 0;
  opacity: 0;
  overflow: hidden;
}

.lista-extras-interna {
  list-style: none;
  padding: 12px 15px;
  margin: 10px 0 5px 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.03);
}

.lista-extras-interna li {
  font-family: 'Montserrat', sans-serif;
  color: #b5b5b5;
  font-size: 0.82rem;
  margin-bottom: 8px;
  line-height: 1.4;
}

.lista-extras-interna li:last-child {
  margin-bottom: 0;
}

.lista-extras-interna li span {
  color: #f0b2bc;
  font-weight: 700;
}

.btn-seleccionar {
  position: relative;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 20px;
  border-radius: 35px;
  cursor: pointer;
  overflow: hidden;
  text-align: center;
  transition: border-color 0.4s ease;
  width: 100%;
}

.btn-premium-action {
  border-color: rgba(240, 178, 188, 0.3);
}

.paquete-card:hover .btn-seleccionar {
  border-color: #f0b2bc;
}

.paquete-card:hover .btn-glow {
  opacity: 0.15;
}

.extras-visibles {
  margin-top: 60px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 45px;
  text-align: left;
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
}

.extras-title {
  font-family: 'ludovica', serif;
  color: white;
  font-size: 1.8rem;
  font-weight: 400;
  margin: 0 0 25px;
  letter-spacing: 1px;
  text-align: center;
}

.lista-extras {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  max-width: 650px;
}

.lista-extras li {
  font-family: 'Montserrat', sans-serif;
  color: #cccccc;
  font-size: 0.95rem;
  margin-bottom: 15px;
  line-height: 1.5;
  position: relative;
  padding-left: 20px;
}

.lista-extras li::before {
  content: "✦";
  position: absolute;
  left: 0;
  color: #f0b2bc;
}

.lista-extras li span {
  color: #f0b2bc;
  font-weight: 700;
}

.nota-subdominio {
  font-family: 'Montserrat', sans-serif;
  color: #999999;
  font-size: 0.9rem;
  margin-top: 30px;
  text-align: center;
  font-style: italic;
}

.beneficio-footer {
  margin-top: 55px;
  max-width: 750px;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px dashed rgba(255, 255, 255, 0.06);
  padding-top: 35px;
}

.beneficio-footer h3 {
  font-family: 'ludovica', serif;
  color: #f0b2bc;
  font-size: 1.8rem;
  margin: 0 0 12px;
  font-weight: 400;
}

.beneficio-footer p {
  color: #a5a5a5;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

.btn-text {
  position: relative;
  z-index: 2;
  color: white;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 0.8rem;
  text-transform: uppercase;
}
.btn-glow {
  position: absolute;
  inset: 0;
  background: linear-gradient(45deg, #e293a0, #f0b2bc);
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 1;
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .paquetes-grid {
    grid-template-columns: 1fr;
    max-width: 480px;
  }
  .paquetes-title {
    font-size: 3rem;
  }
}

@media (max-width: 767px) {
  .paquetes-title {
    font-size: 2.3rem;
  }
}
</style>